export function formatNumberIndianStyle(number: number) {
  return new Intl.NumberFormat("en-IN").format(number);
}

export function toRupees(amount: number) {
  return `₹${toIndianNumber(amount)}`;
}

export function toIndianNumber(amount: number) {
  return formatNumberIndianStyle(amount);
}

export function maskPhoneNumber(phoneNumber: string) {
  return phoneNumber.replace(/\d{6}/, "******");
}

// Returns the value as integer if no fraction digits, else rounds to max two fraction digits
export function toDisplayNumber(value: number): string {
  if (Number.isInteger(value)) {
    return value.toString();
  }
  return value.toFixed(2).replace(/\.00$/, "");
}

/**
 * Formats a coin value by removing decimal places and formatting in Indian number style
 * @param value - The coin value to format
 * @returns Formatted string without decimal places
 */
export function roundOffCoins(value: number | string): string {
  // Convert string to number if needed
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  // Handle NaN cases
  if (isNaN(numValue)) return "0";

  // Round down to nearest integer and format in Indian style
  return formatNumberIndianStyle(Math.floor(numValue));
}
